import { BaseCurrencyInput, Input, Label, Radio, Select } from "@components";
import { useEffect, useState } from "react";

export const TimeForm = ({ range, onChange }) => {
  const [type, setType] = useState(range?.type || null);
  const [period, setPeriod] = useState(range?.period || "day");
  const [min, setMin] = useState(range?.min || null);
  const [max, setMax] = useState(range?.max || null);

  const getFreshNode = () => {
    return { type, period, min, max };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [type, period, min, max]);

  const changeType = (type) => {
    setType((oldType) => {
      if (oldType != type) {
        setPeriod("day");
        setMin(null);
        setMax(null);
      }
      return type;
    });
  };

  return (
    <>
      <Radio
        text="Todo o período"
        family="time"
        value={null}
        checked={type}
        className="mt-15 mb-15"
        onChange={() => changeType(null)}
      />

      <Radio
        text="Nos últimos"
        family="time"
        value="in_last"
        checked={type}
        className="mb-15"
        onChange={() => changeType("in_last")}
      />

      <Radio
        text="A mais de"
        family="time"
        value="more_than"
        checked={type}
        className="mb-15"
        onChange={() => changeType("more_than")}
      />

      <Radio
        text="Período personalizado"
        family="time"
        value="range"
        checked={type}
        onChange={() => changeType("range")}
      />

      {["in_last", "more_than"].includes(type) && (
        <>
          <div className="d-flex mt-15">
            <BaseCurrencyInput
              placeholder="Inserir valor"
              className="w-50 mb-0 pt-0"
              precision={0}
              prefix=""
              type="tel"
              value={min}
              onChange={(v) => setMin(v)}
            />
            <Select
              title="Selecione o tempo..."
              className="w-50 ml-15 mb-0"
              value={period}
              options={[
                { label: "Dias", value: "day" },
                { label: "Meses", value: "month" },
                { label: "Anos", value: "year" },
              ]}
              onChange={(e) => setPeriod(e.target.value)}
            />
          </div>
        </>
      )}

      {type === "range" && (
        <>
          <div className="d-flex mt-15">
            <div className="d-flex flex-column w-50">
              <Label mini>De</Label>
              <Input
                placeholder="dd/mm/aaaa"
                mask="99/99/9999"
                type="tel"
                value={min}
                onChange={(e) => setMin(e.target.value)}
                className="mb-0"
              />
            </div>
            <div className="d-flex flex-column w-50 ml-15">
              <Label mini>Até</Label>
              <Input
                placeholder="dd/mm/aaaa"
                mask="99/99/9999"
                type="tel"
                value={max}
                onChange={(e) => setMax(e.target.value)}
                className="mb-0"
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};
